module.exports = __webpack_public_path__ + "images/application/i-cc@2x-cf235d34.png";